module.exports = __webpack_public_path__ + "img/banner.c65e9728.png";